<template>
  <v-container v-if="!isExpired" fluid class="templates-container pa-0 ma-0">
    <!-- Modern Header Section -->
    <v-row v-if="showHeader" class="pa-0 ma-0 px-3 mb-4">
      <v-col cols="12" class="pa-0">
        <div class="header-section mb-4" style="position: relative;">
          <v-btn icon small class="header-close-btn" @click="dismissHeader">
            <v-icon color="white">mdi-close</v-icon>
          </v-btn>
          <v-container fluid class="px-3">
            <v-row align="center" class="pa-0 ma-0">
              <v-col cols="12" md="8" class="d-flex align-center pa-0">
                <div class="header-icon-wrapper mr-4">
                  <v-icon size="32" color="#FFFFFF"
                    >mdi-file-document-multiple-outline</v-icon
                  >
                </div>
                <div>
                  <h1 class="page-title mb-1">WhatsApp Templates</h1>
                  <p class="page-subtitle mb-0">
                    Create and manage message templates for your campaigns
                  </p>
                </div>
              </v-col>
              <v-col cols="12" md="4" class="text-right pa-0">
                <v-chip small color="rgba(255,255,255,0.2)" text-color="white">
                  <v-icon small left color="white">mdi-whatsapp</v-icon>WhatsApp
                </v-chip>
              </v-col>
            </v-row>
            <v-row class="mt-4">
              <v-col cols="12" class="pa-0">
                <div class="feature-pills-container">
                  <div class="feature-pill">
                    <v-icon small class="mr-2" color="white"
                      >mdi-text-box-multiple</v-icon
                    >
                    Message Templates
                  </div>
                  <div class="feature-pill">
                    <v-icon small class="mr-2" color="white"
                      >mdi-image-multiple</v-icon
                    >
                    Media Support
                  </div>
                  <div class="feature-pill">
                    <v-icon small class="mr-2" color="white"
                      >mdi-check-circle</v-icon
                    >
                    Approved Templates
                  </div>
                  <div class="feature-pill">
                    <v-icon small class="mr-2" color="white"
                      >mdi-cog-outline</v-icon
                    >
                    Custom Variables
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </div>
      </v-col>
    </v-row>

    <!-- <v-container
      v-if="
        !isConnected &&
          !whatsappRegistered &&
          !firstTimeTemplate &&
          templates.length <= 0
      "
      fluid
      class="whiteBackGround"
    >
      <first-page
        :img-src="imgSrc"
        :dialog-name.sync="firstTimeTemplate"
        :points="points"
        :headline="headline"
      ></first-page>
    </v-container> -->

    <v-layout row style="margin: 0px !important">
      <v-flex
        v-if="!isConnected && !whatsappRegistered"
        xs12
        sm12
        md12
        style="padding-bottom: 1%;padding-top:1%"
      >
        <WhatsappConnector
          :is-connected="isConnected"
          :whatsapp-registered="whatsappRegistered"
          :set-chat-show="setChatShow"
        />
      </v-flex>

      <v-container
        v-if="!isConnected && !whatsappRegistered && !firstTimeTemplate"
        fluid
        class="whiteBackGround customBorderRadius"
      >
        <first-page
          :img-src="imgSrc"
          :dialog-name.sync="firstTimeTemplate"
          :points="points"
          :headline="headline"
        ></first-page>
      </v-container>

      <v-flex
        v-else-if="isConnected && whatsappRegistered"
        xs12
        sm12
        md12
        style="padding: 5px"
      >
        <v-card class="rounded customBorderRadius ma-2">
          <v-card-title>
            Templates
            <v-spacer></v-spacer>

            <!-- Search Field -->
            <!-- <v-text-field v-model="search" label="Search Templates" prepend-inner-icon="mdi-magnify" solo dense
              clearable class="search-bar pt-6"></v-text-field> -->

            <div>
              <v-btn
                class="ma-md-2"
                dark
                color="primarygrad"
                label
                :to="{
                  path: `/whatsapp-templates/add`,
                  query: { page: 'Whatsapp' },
                }"
              >
                <v-icon left>
                  add
                </v-icon>
                Add a Template
              </v-btn>
            </div>
          </v-card-title>

          <v-card-text>
            <div v-if="preloader" style="text-align: center; padding: 25px">
              <v-row
                class="fill-height"
                align-content="center"
                justify="center"
              >
                <v-col class="subtitle-1 text-center" cols="12">
                  Please Wait
                </v-col>
                <v-col cols="6">
                  <v-progress-linear
                    color="primary"
                    indeterminate
                    rounded
                    height="6"
                  ></v-progress-linear>
                </v-col>
              </v-row>
            </div>

            <div v-else-if="filteredTemplates.length">
              <v-data-table
                :headers="headers"
                :items="filteredTemplates"
                :items-per-page="filteredTemplates.length"
                item-key="id"
                hide-default-footer
                disable-sort
              >
                <template v-slot:[`item.name`]="{ item }">
                  {{ item.name }}
                </template>
                <template v-slot:[`item.headerFormat`]="{ item }">
                  {{
                    item.components.some((comp) => comp.type === "HEADER")
                      ? item.components.find((comp) => comp.type === "HEADER")
                          .format
                      : ""
                  }}
                </template>
                <template v-slot:[`item.header`]="{ item }">
                  {{
                    item.components.some((comp) => comp.type === "HEADER")
                      ? item.components.find((comp) => comp.type === "HEADER")
                          .format === "TEXT"
                        ? item.components.find((comp) => comp.type === "HEADER")
                            .text
                        : item.components.find((comp) => comp.type === "HEADER")
                            .format
                      : ""
                  }}
                </template>
                <template v-slot:[`item.body`]="{ item }">
                  {{
                    item.components.find((comp) => comp.type === "BODY").text
                  }}
                </template>
                <template v-slot:[`item.footer`]="{ item }">
                  {{
                    item.components.some((comp) => comp.type === "FOOTER")
                      ? item.components.find((comp) => comp.type === "FOOTER")
                          .text
                      : ""
                  }}
                </template>
                <template v-slot:[`item.status`]="{ item }">
                  {{ item.status }}
                </template>
              </v-data-table>
            </div>

            <div v-else style="text-align: center; padding: 10px;">
              <v-alert type="info"
                >No templates found matching your search.</v-alert
              >
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <PayWallCard
      title="Unlock WhatsApp Templates"
      description="Create and manage message templates for faster communication"
      badge="Premium Feature"
      badge-icon="mdi-whatsapp"
      badge-color="success"
      :features="whatsappFeatures"
      button-text="Upgrade Now"
      @update-is-expired="handlePaywallUpdate"
    />
  </v-container>

  <v-container v-else fluid text-xs-center>
    <PayWallCard
      title="Unlock WhatsApp Templates"
      description="Create and manage message templates for faster communication"
      badge="Premium Feature"
      badge-icon="mdi-whatsapp"
      badge-color="success"
      :features="whatsappFeatures"
      button-text="Upgrade Now"
      @update-is-expired="handlePaywallUpdate"
    />
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import Breadcrumbs from "@/components/breadcrumbs.vue";
import WhatsappConnector from "../../components/whatsappConnector.vue";
import PayWallCard from "@/components/payWallCard.vue";
import firstPage from "@/components/firstPage.vue";

export default {
  components: {
    Breadcrumbs,
    WhatsappConnector,
    firstPage,
    PayWallCard,
  },
  data() {
    return {
      showHeader: false,
      isExpired: false,
      search: "",
      firstTimeTemplate: false,
      noDialog: false,
      headline: "Build Your Own Template Library",
      points: [
        "Stop Wasting Time Typing: Create custom templates for common messages, freeing up your team to focus on personalized interactions",
        "Broadcast Like a Pro: Effortlessly send pre-designed templates to large groups, saving time and reaching more customers",
        "Maintain Brand Consistency: Ensure all your team's messages are clear, concise, and on-brand with a library of reusable templates.",
      ],
      whatsappFeatures: [
        "Create reusable message templates",
        "Pre-approved templates for broadcasts",
        "Rich media support (images, documents)",
        "Variable placeholders for personalization",
      ],
      isConnected: false,
      whatsappRegistered: false,
      templates: [],
      allTemplates: [],
      preloader: false,
      headers: [
        { text: "Name", value: "name" },
        { text: "Header Format", value: "headerFormat" },
        { text: "Header", value: "header" },
        { text: "Body", value: "body" },
        { text: "Footer", value: "footer" },
        { text: "Status", value: "status" },
      ],
    };
  },
  computed: {
    ...mapGetters([
      "ENDPOINT",
      "dispoList",
      "teams",
      "user",
      "selectedTeam",
      "selectedList",
    ]),
    imgSrc() {
      return require("@/assets/gotemplate.svg");
    },
    filteredTemplates() {
      if (!this.search) {
        return this.templates; // Return all templates if no search term
      }

      const lowerSearch = this.search.toLowerCase();

      return this.templates.filter((template) =>
        template.name.toLowerCase().includes(lowerSearch),
      );
    },
  },
  async created() {
    this.showHeader =
      localStorage.getItem("whatsappTemplatesHeaderDismissed") !== "true";
    const getIntegration = await this.$http.get(
      `${this.ENDPOINT}/integrations?filter[where][companyId]=${this.user.companyId}&filter[where][type]=whatsapp`,
    );

    if (
      getIntegration.body.length &&
      getIntegration.body[0].config.initializeDone
    ) {
      this.setChatShow();
      this.getTemplates();
    }

    // this.getMessages();
  },
  methods: {
    dismissHeader() {
      this.showHeader = false;
      localStorage.setItem("whatsappTemplatesHeaderDismissed", "true");
    },
    handlePaywallUpdate(expiredStatus) {
      this.isExpired = expiredStatus;
    },
    setChatShow() {
      this.isConnected = true;
      this.whatsappRegistered = true;
      this.firstTimeTemplate = true;
    },
    filterByLink(active) {
      if (active) {
        this.templates = _.filter(this.allTemplates, (t) => {
          return t.isLink;
        });
        return;
      }

      this.templates = this.allTemplates;
    },

    getTemplates() {
      var self = this;
      this.preloader = true;
      this.templates = [];
      this.$http
        .get(this.$store.state.ENDPOINT + "/whatsapps/getTemplates")
        .then(
          (response) => {
            self.preloader = false;
            response = response.body;
            if (response && response.data && Array.isArray(response.data)) {
              this.templates = response.data;

              console.log("all templates: ", this.templates);

              // this.templates = _.filter(response.data, { status: "APPROVED" });
            } else {
              this.$swal({
                type: "error",
                text: "Invalid response format while loading the templates.",
              });
            }
            this.preloader = false;
          },
          (error) => {
            this.preloader = false;
            this.$swal({
              type: "error",
              text: "Something went wrong while loading the templates.",
            });
          },
        );
    },
  },
};
</script>

<style scoped>
.templates-container {
  background-color: var(--v-background-base, #f5f5f5);
}

.theme--dark .templates-container {
  background-color: #121212 !important;
}
</style>
